import { render } from "./NewChatForm.vue?vue&type=template&id=16700592&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=16700592&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16700592"

export default script